module.exports = "<div gw-pl-ctrl-group label=\"{{label}}\" model=\"model\" help-tip=\"{{helpTip}}\">\n    <div gw-pl-binary-choice\n         model=\"model\"\n         title-left=\"{{titleLeft}}\" title-right=\"{{titleRight}}\"\n         value-left=\"valueLeft\" value-right=\"valueRight\">\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/inputs/templates/binary-choice-group.html
 ** module id = 598
 ** module chunks = 0
 **/